import { buildPlayerTeamWorkspacePath } from './playerTeamWorkspace';

/**
 * @param {object} team — roster row from playerAPI.getTeams()
 * @param {string} section
 * @param {Record<string, string>} [extraQuery]
 */
export function buildHelpTeamWorkspacePath(team, section, extraQuery = {}) {
  const teamId = team?.teamId || team?.team_id;
  if (!teamId) return '/player/teams';
  return buildPlayerTeamWorkspacePath(teamId, section, {
    tenant_id: team?.tenantId || team?.tenant_id || '',
    season_id: team?.latestSeasonId || team?.latest_season_id || '',
    campaign_id: team?.campaignId || team?.campaign_id || '',
    ...extraQuery,
  });
}

/** Normalize roster team row for wizard context */
export function normalizeWizardTeamContext(team) {
  if (!team) return null;
  const teamId = team.teamId || team.team_id;
  if (!teamId) return null;
  return {
    teamId: String(teamId),
    teamName: team.teamName || team.team_name || `Team ${String(teamId).slice(0, 8)}`,
    tenantId: team.tenantId ?? team.tenant_id ?? '',
    seasonId: team.latestSeasonId ?? team.latest_season_id ?? '',
    campaignId: team.campaignId ?? team.campaign_id ?? '',
  };
}
